module.exports = "/_next/static/images/slide03-abac51418fd8c7cc8e14560d3cdd0b72.png";